export const API_GET_GESLAB_EXPORT = 'API_GET_GESLAB_EXPORT';
export const API_GET_GESLAB_EXPORT_SUCCESS = 'API_GET_GESLAB_EXPORT_SUCCESS';
export const API_GET_GESLAB_EXPORT_FAIL = 'API_GET_GESLAB_EXPORT_FAIL';
export const API_GET_GESLAB_IMPORT = 'API_GET_GESLAB_IMPORT';
export const API_GET_GESLAB_IMPORT_SUCCESS = 'API_GET_GESLAB_IMPORT_SUCCESS';
export const API_GET_GESLAB_IMPORT_FAIL = 'API_GET_GESLAB_IMPORT_FAIL';

